import { useEffect, useState, useSyncExternalStore } from 'react';
import { create } from 'zustand';

const antiZoomStore = create<{ value: number }>(() => ({ value: 1 }));

export const ANTI_ZOOM_FACTOR_PER_VIEWPORT_HEIGHT = 0.02;

// 17% was chosen by trial and error
export const MAX_LABEL_HEIGHT_FRACTION_OF_VIEWPORT = 0.17;

export function isLabelTooTallForViewport(labelHeight: number, antiZoomFactor: number): boolean {
  const viewportHeight = antiZoomFactor / ANTI_ZOOM_FACTOR_PER_VIEWPORT_HEIGHT;
  return labelHeight / viewportHeight > MAX_LABEL_HEIGHT_FRACTION_OF_VIEWPORT;
}

export const useAntiZoomFactor = () => useSyncExternalStore(antiZoomStore.subscribe, () => antiZoomStore.getState());

export function subscribeToAntiZoomFactor(listener: (value: number) => void): () => void {
  return antiZoomStore.subscribe(({ value }) => void listener(value));
}

// Note that you must ensure this is called during the same frame that the zoom level changes to avoid visual glitches
//   and/or unnecessary renders.
export function updateAntiZoomFactor(value: number): void {
  if (value !== antiZoomStore.getState().value) {
    antiZoomStore.setState({ value });
  }
}

export function useAntiZoomCheck(predicate: (value: number) => boolean): boolean {
  const [passesCheck, setPassesCheck] = useState(() => predicate(antiZoomStore.getState().value));

  useEffect(() =>
    subscribeToAntiZoomFactor((value) => {
      setPassesCheck(predicate(value));
    }),
  );

  return passesCheck;
}
